import { Component, OnInit } from '@angular/core';
import { RmsModule } from '@rms';
import { Column } from '@interfaces';
import { LedgerService, RmsMessageService } from '@services';

@Component({
  selector: 'app-ledger-unresolved',
  imports: [RmsModule],
  templateUrl: './ledger-unresolved.component.html',
  styleUrl: './ledger-unresolved.component.scss'
})
export class LedgerUnresolvedComponent implements OnInit {
  Groups: any[] = [];
  Ledger: { LedgerRowCount: number; NetAmount: number } | null = null;
  Loading = true;

  Columns: Column[] = [
    { label: 'Legacy Mode', key: 'LegacyModeOfPayment', width: 10 },
    { label: 'Legacy Detail Type', key: 'LegacyPaymentDetailTypeID', width: 12 },
    { label: 'Legacy Description', key: 'DetailDisplay', width: 26 },
    { label: 'Payments', key: 'PaymentCount', type: 'number', width: 10, align: 'right' },
    { label: 'Total Amount', key: 'TotalAmount', type: 'currency', width: 14, align: 'right' },
    { label: 'First Date', key: 'FirstDate', type: 'date', width: 12 },
    { label: 'Last Date', key: 'LastDate', type: 'date', width: 12 }
  ];

  constructor(private ledger: LedgerService, private message: RmsMessageService) { }

  ngOnInit() {
    this.ledger.getUnresolvedSummary().subscribe({
      next: (result) => {
        this.Loading = false;
        this.Ledger = result?.ledger || null;
        this.Groups = (result?.payments || []).map((g: any) => ({ ...g, DetailDisplay: g.LegacyPaymentDetailName || 'No detail type recorded' }));
      },
      error: (err) => {
        this.Loading = false;
        this.message.error('Failed to load unresolved payment codes: ' + (err?.error?.error || err?.message || 'Unknown error'));
      }
    });
  }

  get TotalPayments(): number {
    return this.Groups.reduce((sum, g) => sum + (g.PaymentCount || 0), 0);
  }

  get TotalAmount(): number {
    return this.Groups.reduce((sum, g) => sum + (g.TotalAmount || 0), 0);
  }
}
